import { maxAssetInputLength } from '@/shared/constants/constants';
import { cryptoAmountValidation } from '@/shared/helpers/crypto';
import { WITHDRAWAL_LIMITS } from '@/shared/utils/constants';
import { IonButton, IonNote } from '@ionic/react';
import { t } from 'i18next';
import { useState } from 'react';
import LabelOutInput from '../LabelOutInput/LabelOutInput';
import styles from './GenericFormInput.module.css';

type Props = {
  assetId?: string;
  displayValue: string | null;
  errorMessage?: string | null;
  fixedLabel?: string | null;
  handleMaxAction?: () => void;
  id: string;
  inputmode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  isValidUserInput?: boolean | null;
  label: string;
  max?: number;
  name: string;
  setValue: (value) => void;
  showValidityInfo?: boolean;
  type?: string;
  disabled?: boolean;
};

const GenericFormInput: React.FC<Props> = ({
  assetId,
  displayValue,
  errorMessage,
  fixedLabel,
  handleMaxAction,
  id,
  inputmode,
  isValidUserInput,
  label,
  max,
  name,
  setValue,
  showValidityInfo,
  type,
  disabled
}) => {
  const [separatorDetected, setSeparatorDetected] = useState(false);

  const handleKeyDown = (event) => {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];

    const key = event.key;

    if (separatorDetected) {
      if (/[^0-9]/.test(key) && !allowedKeys.includes(key)) {
        event.preventDefault();
      }
    } else {
      if (/[^0-9.,]/.test(key) && !allowedKeys.includes(key)) {
        event.preventDefault();
      }
    }
  };

  return (
    <div className={`${styles.inputWrapper}`}>
      <div className={`${styles.inputContainer} ${type === 'address' ? styles.maxWidth : ''}`}>
        <LabelOutInput
          aria-label={name}
          id={id}
          inputMode={inputmode}
          maxlength={
            max && type !== 'address'
              ? max
              : type === 'address'
                ? undefined
                : max && (type === 'amount' || 'withdrawalAmount')
                  ? max
                  : maxAssetInputLength
          }
          minlength={1}
          name={name}
          type="tel"
          value={displayValue}
          onKeyDown={type === 'withdrawalAmount' ? handleKeyDown : undefined}
          onIonInput={(event) => {
            if (type === 'withdrawalAmount') {
              setSeparatorDetected(cryptoAmountValidation(event.target.value));
              setValue(event.target.value?.toString());
            } else {
              const value = event.target.value?.toString();
              setValue(value);
            }
          }}
          labelPlacement="floating"
          label={label}
          fill="outline"
          color={
            !isValidUserInput && showValidityInfo
              ? 'danger'
              : isValidUserInput && showValidityInfo
                ? 'success'
                : styles.labelColor
          }
          disabled={disabled}
        />
      </div>
      {fixedLabel && <div className={styles.iconLabel}>{fixedLabel}</div>}

      {(showValidityInfo || isValidUserInput) && (
        <IonNote className={errorMessage ? styles.error : ''} slot="error">
          {errorMessage &&
            t(errorMessage, {
              amount: WITHDRAWAL_LIMITS[assetId || ''],
              assetName: assetId?.toUpperCase()
            })}
        </IonNote>
      )}
      {handleMaxAction && (
        <IonButton className={styles.max} onClick={handleMaxAction} shape="round" size="small">
          {t('general.total.buy.max.hybrid')}
        </IonButton>
      )}
    </div>
  );
};

export default GenericFormInput;
